// extracted by mini-css-extract-plugin
export default {"filterContainer":"styles_filterContainer__4xiEo","pagination":"styles_pagination__3G0KJ"};